<template>
  <BaseModal
    :show="show"
    height="85%"
    :title="`${kundeVorname} ${kundeNachname}`"
    @close="$emit('close')"
  >
    <div class="flex flex-col h-full">
      <BrokerInfo v-if="isMobile" />
      <div class="flex flex-col divide-y divide-gray-100 px-0.5 mt-3">
        <div
          v-for="item in menuItems"
          :key="item.label"
        >
          <RouterLink
            :to="item.to"
            class="flex flex-row items-center gap-3 hover:bg-gray-100 rounded px-2 py-2.5 hover:no-underline my-1 text-gray-900 hover:text-gray-900"
            @click.prevent="$emit('close')"
          >
            <DsIcon
              :name="item.icon"
              variant="light"
              size="lg"
              fixed-width
            />
            <div class="text-base relative">
              {{ item.label }}
              <MenuHint
                v-if="item.unreadHints"
                :number="item.unreadHints"
              />
            </div>
          </RouterLink>
        </div>
      </div>

      <div class="border-t border-gray-100 px-0.5">
        <button
          class="flex flex-row items-center gap-3 hover:bg-gray-100 rounded px-2 py-2.5 mt-1 text-gray-900 cursor-pointer w-full"
          @click.prevent="userStore.logUserOutByUser"
        >
          <DsIcon
            name="right-from-bracket"
            variant="light"
            size="lg"
            fixed-width
          />
          <span class="text-base">Abmelden</span>
        </button>
      </div>

      <div class="flex flex-row items-center justify-center gap-3 print:hidden mt-5 text-xs text-gray-500">
        Version: {{ versionString }}
      </div>

      <div class="flex flex-row items-center justify-center gap-5 print:hidden mt-3 text-sm">
        <a
          v-if="isProductionEnv"
          href="#"
          onclick="CCM.openWidget();return false;"
          class="text-gray-700"
        >Cookies</a>
        <RouterLink
          :to="{ name: Finanzmanager.DATENSCHUTZ }"
          class="text-gray-700"
          @click.prevent="$emit('close')"
        >
          Datenschutz
        </RouterLink>
        <RouterLink
          :to="{ name: Finanzmanager.IMPRESSUM }"
          class="text-gray-700"
          @click.prevent="$emit('close')"
        >
          Impressum
        </RouterLink>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { DsIcon } from '@demvsystems/design-components';
import { storeToRefs } from 'pinia';
import { ref, computed } from 'vue';

import { Finanzmanager } from '@/application/router/types/types';
import { useBaseDataStore } from '@/user/store/baseDataStore';
import MenuHint from "@/application/menu/components/MenuHint.vue";
import { useUnreadHintStore } from "@/application/store/unreadHintStore";
import { UnreadHintType } from "@/api/unreadHint/types";
import { isProductionEnv } from "@/application/utils/envInfo";
import { useEnvInfo } from "@/application/composables/envInfo";
import { useUserStore } from "@/user/store/userStore";
import BaseModal from '@/application/components/BaseModal.vue';
import BrokerInfo from '@/application/components/BrokerInfo.vue';
import { useDetectMobile } from '@/application/composables/detectMobile.ts';

defineOptions({ inheritAttrs: false });

defineProps<{ show: boolean }>();
defineEmits(['close']);

const { versionString } = useEnvInfo();
const { isMobile } = useDetectMobile();
const userStore = useUserStore();
const unreadNews = useUnreadHintStore()
const newsCnt = computed(() => unreadNews[UnreadHintType.News].size);
const { isCompany, kundeVorname, kundeNachname } = storeToRefs(useBaseDataStore());

const menuItems = ref([
  { label: isCompany.value ? 'Unsere Daten' : 'Meine Daten', to: { name: Finanzmanager.DATEN }, icon: 'address-card' },
  { label: 'Bankverbindungen', to: { name: Finanzmanager.BANK_ACCOUNTS }, icon: 'money-check-dollar' },
  { label: isCompany.value ? 'Unser Account' : 'Mein Account', to: { name: Finanzmanager.ACCOUNT }, icon: 'user' },
  { label: 'Hinweise', to: { name: Finanzmanager.HINWEISE }, icon: 'circle-info', unreadHints: newsCnt },
]);
</script>
